var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApostrophes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1191_156)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.727 19.1109H30.1632V14.6126C30.1632 10.2908 31.0823 7.40199 33.0482 5.52242C35.1153 3.5453 37.5126 2.44232 40.0112 2.30351V0C36.1208 0.168824 33.2283 2.16845 31.4575 3.86044C29.0377 6.17145 27.8634 9.69049 27.8634 14.6126V35.7081C27.8634 38.0754 29.788 40 32.1553 40H44.727C47.0943 40 49.0189 38.0754 49.0189 35.7081V23.4027C49.0189 21.0355 47.0943 19.1109 44.727 19.1109Z",
    fill: "#1CCEDC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8636 19.1109H2.29976V14.6126C2.29976 10.2908 3.21891 7.40199 5.18477 5.52242C7.25192 3.5453 9.64922 2.44232 12.1478 2.30351V0C8.25736 0.168824 5.36485 2.16845 3.59407 3.86044C1.17426 6.17145 0 9.69049 0 14.6126V35.7081C0 38.0754 1.92459 40 4.29188 40H16.8636C19.2309 40 21.1555 38.0754 21.1555 35.7081V23.4027C21.1555 21.0355 19.2309 19.1109 16.8636 19.1109Z",
    fill: "#1CCEDC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1191_156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.0189,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApostrophes);
export default __webpack_public_path__ + "static/media/apostrophes.eab8fb1bcf30dc47b95256772ac42cb7.svg";
export { ForwardRef as ReactComponent };